import { map, mergeMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { calendarService } from '../../../common/services';
import * as actionTypes from './actionTypes';
import * as audiencesActions from './actions';

export function fetchAudiences(action$) {
  return action$.pipe(
    ofType(actionTypes.FETCH_AUDIENCES),
    mergeMap(({ payload }) => {
      return calendarService.getAudiences(payload)
        .pipe(
          map(res => audiencesActions.fetchAudiencesSuccess(res.responceObject.records)),
          catchError(error => {
            console.log(error)
          })
        )
    })
  )
}